const ALIGN_ELEMENTS_MODEL = [
  {
    key: 'xAlign',
    values: ['left', 'center', 'right']
  },
  {
    key: 'yAlign',
    values: ['top', 'middle', 'bottom']
  }
]

export default {
  name: 'alignElementsProjectMenu',
  data () {
    return {
      alignElementsModel: ALIGN_ELEMENTS_MODEL,
      alignElementsData: {
        xAlign: null,
        yAlign: null
      }
    }
  },
  methods: {
    handleAlignElementChange (value, key) {
      if (!this.alignElementsData) {
        this.alignElementsData = {
          xAlign: null,
          yAlign: null
        }
      }

      this.alignElementsData[key] = value
      this.$emit('select-alignment', { ...this.alignElementsData })
    }
  }
}
